import React from 'react';
import { POSITIONS_SETTINGS_FILTERS_SLUGS } from '../../../constants';
import usePositionsSettingsFilterOptions from '../../../hooks/usePositionsSettingsFilterOptions';
import GenericFilter from './GenericFilter';

const PositionsSettingsBranchesFilter = (props) => {
  const options = usePositionsSettingsFilterOptions();

  return (
    <GenericFilter
      {...props}
      titleKey="branches"
      namePrefix="branch"
      staticOptions={options[POSITIONS_SETTINGS_FILTERS_SLUGS.branches]}
    />
  );
};

export default PositionsSettingsBranchesFilter;
